import axios from 'axios';
import { endPointUrls } from '../store/constants/endPoints';
import store from '../store'; // Added
import { setUserPopupMessage, setUserLogout } from '../store/customSlice/authSlice';
import { setErrorMessage, setErrorMessageContent, setErrorMessageVisible } from '../store/customSlice/scheduleDetailsSlice';

const getBaseURL = () => {
    return window._env.REACT_APP_BASE_API_URL;
};

export const axiosInstance = axios.create({
    baseURL: getBaseURL(),
    headers: {
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': window._env.REACT_APP_BASE_API_URL,
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
        'apikey': window._env.REACT_APP_API_KEY,
        'X-Frame-Options': window._env.REACT_APP_BASE_API_URL,
    },
});

const genrateErrorMessage = (error: any) => {
    let errorMessage = '';
    if(error != null){
    errorMessage = `${error?.errorDetails ? error.errorDetails : error.errorMessage ? error.errorMessage : 'Bad Request'}`;
    }
    return errorMessage;    
};
 
// Request interceptor to dynamically set session ID on each request
axiosInstance.interceptors.request.use(
    (config) => {
        const sessionID = localStorage.getItem('sessionID');
        if (sessionID) {
            config.headers['X-IPT-CONCURRENT-SESSION-ID'] = sessionID;
        }
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
            delete config.headers['Accept'];
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);
 

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {        
        if (error.response) {            
            if (error.response.status === 401) {
                window.location.assign(`${window._env.REACT_APP_BASE_API_URL}${endPointUrls.auth}`);
            } else if (error.response.status === 412) { 
                //no session found or missing session in header 
                //Approach 1
                // window.location.assign(`${window._env.REACT_APP_BASE_API_URL}${endPointUrls.auth}`);
                store.dispatch(setUserLogout(true));
                store.dispatch(setUserPopupMessage(false));
            } else if(error.response.status === 409) {
                //another active session found
                store.dispatch(setUserLogout(false));
                store.dispatch(setUserPopupMessage(true));
            } else if(error.response.status === 417) {
                //in active session
                store.dispatch(setUserLogout(true));
                store.dispatch(setUserPopupMessage(false));
            } else if(error.response.status === 400) {
                store.dispatch(setErrorMessage({
                    errorCode: error.response.data?.error?.errorCode || '400',
                    errorMessage: error.response.data?.error?.errorDetails || 'Bad Request',
                }));
                store.dispatch(setErrorMessageContent(genrateErrorMessage(error.response.data?.error)));
                store.dispatch(setErrorMessageVisible(true));
            }else if(error.response.status === 500) {
                store.dispatch(setErrorMessage({
                    errorCode: error.response.data?.error?.errorCode || '500',
                    errorMessage: error.response.data?.error?.errorMessage || 'Internal Server Error',
                }));
            }
        }
        
       return Promise.reject(error);
    
    },
);
